import React, { useEffect } from 'react';
import Layout from '@/common/Layout';
import { useNavigate } from 'react-router-dom';
import Edit from './components/EditAboutme';
import { message } from 'antd';

import { useDispatch, useSelector } from 'react-redux';
import { get_Payment_ID } from '../ListView/redux/slice';
import {
  hobbies_list,
  sports_list,
  maritialStatus,
  createAboutme,
  get_byID
} from './redux/slice';
import { pageview, event } from '../../utilities/gtag';

const index = () => {
  useEffect(() => {
    document.title = 'Edit your profile - Create and Update personal details';
  }, []);
  useEffect(() => {
    pageview(location.pathname + location.search);
  }, [location]);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    maritial_Status,
    get_hobbies_list,
    get_sports_list,
    createAboutmeloading
  } = useSelector((state) => state.editprofile);

  const { user_data } = useSelector((state) => state.listDashboard);

  useEffect(() => {
    get_hobbies();
    get_sports();
    get_maritialStatus();
    get_listby_id();
    get_userPayment_id();
  }, []);

  // useEffect(() => {
  //   const stepTitle = steps[currentStep]?.title || `Step ${currentStep}`;
  //   event({
  //     action: 'profile_creation',
  //     category: 'Profile Creation Event',
  //     label: stepTitle,
  //     value: currentStep
  //   });
  // }, [currentStep]);

  const matUserData = localStorage.getItem('MAT-User');
  const matUserObject = JSON.parse(matUserData);
  const userId = matUserObject.user_details.id;

  const get_listby_id = () => {
    const payload = userId;
    dispatch(get_byID(payload));
  };

  const get_userPayment_id = () => {
    dispatch(get_Payment_ID());
  };

  const get_hobbies = () => {
    const payload = { type: 'hobby' };
    dispatch(hobbies_list(payload));
  };
  const get_sports = () => {
    const payload = { type: 'sport' };
    dispatch(sports_list(payload));
  };
  const get_maritialStatus = () => {
    const payload = { type: 'user' };
    dispatch(maritialStatus(payload));
  };

  //  Method 3

  const onsubmit = async (values) => {
    event({
      action: 'profile_creation', // event name
      category: 'Profile Creation',
      label: 'Profile Form Submitted',
      value: 1
    });
    console.log('onsubmit', values);
    // createFormData(values);
    let formData = new FormData();

    // formData.append('profile_images', values.files);

    // if (values?.height_ft) {
    //   formData.append('height_ft', values.height_ft);
    // }
    // Add simple fields
    formData.append('height_cms', values.height);
    formData.append('weight', values.weight);
    formData.append('diabled_description', values.disability_text ?? '');
    formData.append(
      'is_disabled',
      values.is_disabled === 'none' ? false : Boolean(values.is_disabled)
    );
    formData.append('marital_status_id', values.marital_status_id);
    formData.append('bio', values.bio);
    formData.append('other_interests', values.other_interests);
    formData.append('self_description', values.self_description);

    // Handle arrays
    const formatInterests = (interests) => {
      return interests.map((id) => ({ hobby_sport_id: id }));
    };

    if (values?.hobby_interests?.length) {
      formData.append(
        'hobby_interests',
        JSON.stringify(formatInterests(values.hobby_interests))
      );
    }

    if (values?.sport_interests?.length) {
      formData.append(
        'sport_interests',
        JSON.stringify(formatInterests(values.sport_interests))
      );
    }

    // const imageFields = ['profilePhoto', 'familyPhoto', 'selfFamilyPhoto'];

    // imageFields.forEach((field) => {
    //   if (values[field]?.fileList?.length) {
    //     values[field].fileList.forEach((file) => {
    //       formData.append('profile_images', file.originFileObj);
    //     });
    //   }
    // });
    // Append images as separate fields
    // if (values.profilePhoto?.fileList?.length) {
    //   formData.append(
    //     'profile_image',
    //     values.profilePhoto.fileList[0].originFileObj
    //   );
    // }
    // if (values.familyPhoto?.fileList?.length) {
    //   formData.append(
    //     'family_image',
    //     values.familyPhoto.fileList[0].originFileObj
    //   );
    // }
    // if (values.selfFamilyPhoto?.fileList?.length) {
    //   formData.append(
    //     'self_image',
    //     values.selfFamilyPhoto.fileList[0].originFileObj
    //   );
    // }

    // 🔥 Use fileData for images
    if (values.profilePhoto) {
      formData.append('profile_image', values.profilePhoto);
    }
    if (values.familyPhoto) {
      formData.append('family_image', values.familyPhoto);
    }
    if (values.selfFamilyPhoto) {
      formData.append('self_image', values.selfFamilyPhoto);
    }

    // const appendFile = (fileList, imageType) => {
    //   if (fileList?.length) {
    //     fileList.forEach((file, index) => {
    //       if (file?.originFileObj) {
    //         // Ensure each file is uniquely named to prevent overwriting
    //         formData.append(`profile_images[${index}]`, file.originFileObj);
    //         formData.append(`profile_images_types[${index}]`, imageType);
    //       }
    //     });
    //   }
    // };
    // // Append profile, family, and self-family photos
    // if (values.profilePhoto?.fileList) {
    //   appendFile(values.profilePhoto.fileList, 'profilePhoto');
    // }

    // if (values.familyPhoto?.fileList) {
    //   appendFile(values.familyPhoto.fileList, 'familyPhoto');
    // }

    // if (values.selfFamilyPhoto?.fileList) {
    //   appendFile(values.selfFamilyPhoto.fileList, 'selfFamilyPhoto');
    // }

    // Debugging: Verify FormData contents
    // for (const pair of formData.entries()) {
    //   console.log(pair[0], pair[1]);
    // }

    // Inspect FormData contents
    // const formDataObject = {};
    // for (let [key, value] of formData.entries()) {
    //   // console.log(key, value);
    //   formDataObject[key] = value;
    // }
    console.log('formData.append', formData);

    // Send to API
    try {
      const response = await dispatch(createAboutme(formData)).unwrap();
      console.log('API Response:', response);
      if (response?.success) {
        localStorage.setItem('profile_id', response.profile_id);
        message.success(response.message || 'Form submitted successfully!');
        // navigate(`/editfamily/${response.profile_id}`);
        navigate(`/editfamily`);
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      message.error(
        error?.message || 'Failed to submit the form. Please try again.'
      );
    }

    // try {
    //   console.log('📤 Submitting FormData...');
    //   const response = await dispatch(createAboutme(formData)).unwrap(); // Dispatch Redux action

    //   if (response?.success) {
    //     localStorage.setItem('profile_id', response.profile_id); // Store profile ID
    //     navigate(`/editfamily/${response.profile_id}`); // Redirect on success
    //   }
    // } catch (error) {
    //   console.error('❌ Error submitting form:', error);
    // }
  };

  // const [form] = Form.useForm();

  // useEffect(() => {
  //   if (user_data?.Profiles?.[0]) {
  //     form.setFieldsValue({
  //       height_ft: user_data.Profiles[0].height_ft || '',
  //       height_in: user_data.Profiles[0].height_in || ''
  //     });
  //   }
  // }, [user_data, form]);

  return (
    <>
      <Layout sider={true}>
        <Edit
          get_hobbies_list={get_hobbies_list}
          get_sports_list={get_sports_list}
          maritial_Status={maritial_Status}
          user_data={user_data}
          loading={createAboutmeloading}
          onsubmit={onsubmit}
        />
      </Layout>
    </>
  );
};

export default index;
